var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1033 10.9182C13.8928 11.1287 13.7665 11.4655 13.8507 11.7602L14.5664 15.9702C14.6085 16.5175 14.2296 16.9805 13.7244 17.0647C13.556 17.0647 13.3876 17.0647 13.2192 16.9805L9.43031 15.0019C9.17771 14.8335 8.84092 14.8335 8.58832 15.0019L4.79938 16.9384C4.33629 17.191 3.7469 16.9805 3.5364 16.5175C3.4522 16.3491 3.4101 16.1386 3.4522 15.9281L4.16789 11.7181C4.20999 11.4234 4.12579 11.0866 3.9153 10.8761L0.884146 7.92919C0.505252 7.5503 0.505252 7.00301 0.884146 6.62411C1.01044 6.49782 1.17884 6.37152 1.38934 6.37152L5.59927 5.74003C5.89396 5.69793 6.18866 5.48743 6.27286 5.23484L8.16733 1.4459C8.41992 0.982804 8.96722 0.814407 9.43031 1.0249C9.59871 1.1091 9.7671 1.2775 9.8513 1.4459L11.7458 5.23484C11.9142 5.48743 12.1247 5.69793 12.4194 5.74003L16.6293 6.37152C17.1345 6.45572 17.4713 6.96091 17.3871 7.4661C17.345 7.6345 17.2608 7.80289 17.1345 7.97129L14.1033 10.9182Z",
    fill: "#F6B93B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActStar);
export default __webpack_public_path__ + "static/media/act_star.596891f9750f139958ace81e3e708e11.svg";
export { ForwardRef as ReactComponent };